/**
 * Cart Drawer for Shopify — Impulse Theme Compatible
 */
(function () {
  'use strict';

  const TIERS = [
    { threshold: 60, discount: 5 },
    { threshold: 120, discount: 10 },
    { threshold: 200, discount: 20 },
  ];

  const MONEY_FORMAT = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || (window.Shopify && window.Shopify.money_format) || '${{amount}}';

  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-drawer-overlay');
  const closeBtn = document.getElementById('cart-drawer-close');
  const itemsContainer = document.getElementById('cart-drawer-items');
  const emptyState = document.getElementById('cart-drawer-empty');
  const footer = document.getElementById('cart-drawer-footer');
  const subtotalEl = document.getElementById('cart-subtotal');
  const progressText = document.getElementById('cart-progress-text');
  const progressFill = document.getElementById('cart-progress-fill');
  const progressDot = document.getElementById('cart-dot-current');

  if (!drawer || !overlay) return;

  // ─── Open / Close ───
  function openDrawer() {
    // Close Impulse's own cart drawer if open
    var impulseCartDrawer = document.getElementById('CartDrawer');
    if (impulseCartDrawer && impulseCartDrawer.classList.contains('js-drawer-open')) {
      impulseCartDrawer.classList.remove('js-drawer-open');
    }

    // Randomize urgency count each time drawer opens (between 5 and 14)
    var urgencyEl = document.getElementById('cart-urgency-count');
    if (urgencyEl) {
      urgencyEl.textContent = Math.floor(Math.random() * 10) + 5;
    }

    // Hide any sticky/fixed bars at the bottom (app-injected)
    document.querySelectorAll('body > div, body > section, #PageContainer ~ div, #PageContainer ~ section').forEach(function (el) {
      var style = window.getComputedStyle(el);
      if ((style.position === 'fixed' || style.position === 'sticky') && el.id !== 'cart-drawer' && el.id !== 'cart-drawer-overlay' && !el.classList.contains('cart-drawer') && !el.classList.contains('cart-drawer-overlay')) {
        el.setAttribute('data-cart-drawer-hidden', 'true');
        el.style.setProperty('display', 'none', 'important');
      }
    });

    drawer.classList.add('is-open');
    overlay.classList.add('is-active');
    document.body.classList.add('cart-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    // Restore hidden sticky bars
    document.querySelectorAll('[data-cart-drawer-hidden]').forEach(function (el) {
      el.removeAttribute('data-cart-drawer-hidden');
      el.style.removeProperty('display');
    });

    drawer.classList.remove('is-open');
    overlay.classList.remove('is-active');
    document.body.classList.remove('cart-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // ─── Money formatting ───
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return MONEY_FORMAT.replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
  }

  // ─── Progress bar ───
  function updateProgress(totalCents) {
    var totalDollars = totalCents / 100;

    var nextTierIndex = TIERS.findIndex(function (t) {
      return totalDollars < t.threshold;
    });

    // Tier icons are at 33.33%, 66.66%, 100% of the track
    var fillPercent;
    if (nextTierIndex === -1) {
      fillPercent = 100;
    } else if (nextTierIndex === 0) {
      fillPercent = (totalDollars / TIERS[0].threshold) * 33.33;
    } else {
      var prevThreshold = TIERS[nextTierIndex - 1].threshold;
      var nextThreshold = TIERS[nextTierIndex].threshold;
      var segmentProgress = (totalDollars - prevThreshold) / (nextThreshold - prevThreshold);
      fillPercent = (nextTierIndex * 33.33) + (segmentProgress * 33.33);
    }
    fillPercent = Math.min(fillPercent, 100);

    progressFill.style.width = fillPercent + '%';
    progressDot.style.left = fillPercent + '%';

    TIERS.forEach(function (tier, i) {
      var icon = document.getElementById('tier-' + (i + 1) + '-icon');
      if (icon) {
        if (totalDollars >= tier.threshold) {
          icon.classList.add('is-reached');
        } else {
          icon.classList.remove('is-reached');
        }
      }
    });

    if (nextTierIndex === -1) {
      progressText.innerHTML = "You've unlocked <strong>$" + TIERS[TIERS.length - 1].discount + ' off</strong>!';
    } else {
      var remaining = (TIERS[nextTierIndex].threshold - totalDollars).toFixed(2);
      progressText.innerHTML = 'Add <strong>$' + remaining + '</strong> to unlock <strong>$' + TIERS[nextTierIndex].discount + ' off</strong>';
    }
  }

  // ─── Render cart items ───
  function renderCart(cart) {
    if (cart.item_count === 0) {
      itemsContainer.innerHTML = '';
      emptyState.classList.remove('cart-drawer__empty--hidden');
      footer.classList.add('cart-drawer__footer--hidden');
      document.getElementById('cart-progress').style.display = 'none';
    } else {
      emptyState.classList.add('cart-drawer__empty--hidden');
      footer.classList.remove('cart-drawer__footer--hidden');
      document.getElementById('cart-progress').style.display = '';

      var html = '';
      cart.items.forEach(function (item, index) {
        var imgSrc = '';
        if (item.featured_image) {
          var imgUrl = item.featured_image.url || item.featured_image;
          imgSrc = imgUrl.replace(/(\.\w+)(\?.*)?$/, '_160x$1$2');
        } else if (item.image) {
          imgSrc = item.image.replace(/(\.\w+)(\?.*)?$/, '_160x$1$2');
        }

        var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
          : '';

        html +=
          '<div class="cart-drawer__item" data-line="' + (index + 1) + '" data-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="cart-drawer__item-image">' +
          '<img src="' + imgSrc + '" alt="' + escapeHtml(item.product_title) + '" width="80" height="80" loading="lazy">' +
          '</a>' +
          '<div class="cart-drawer__item-details">' +
          '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
          variantTitle +
          '<div class="cart-drawer__item-bottom">' +
          '<div class="cart-drawer__quantity">' +
          '<button class="cart-drawer__qty-btn" data-action="decrease" data-line="' + (index + 1) + '" aria-label="Decrease quantity">\u2212</button>' +
          '<input type="number" class="cart-drawer__qty-input" value="' + item.quantity + '" min="0" data-line="' + (index + 1) + '" aria-label="Quantity">' +
          '<button class="cart-drawer__qty-btn" data-action="increase" data-line="' + (index + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<span class="cart-drawer__item-price">' +
          (function () {
            var compareData = window.cartDrawerCompareData || {};
            var comparePrice = compareData[item.variant_id];
            if (comparePrice && comparePrice > item.price) {
              return '<span class="cart-drawer__item-price--compare">' + formatMoney(comparePrice * item.quantity) + '</span>' +
                '<span class="cart-drawer__item-price--sale">' + formatMoney(item.final_line_price) + '</span>';
            } else if (item.original_line_price > item.final_line_price) {
              return '<span class="cart-drawer__item-price--compare">' + formatMoney(item.original_line_price) + '</span>' +
                '<span class="cart-drawer__item-price--sale">' + formatMoney(item.final_line_price) + '</span>';
            }
            return formatMoney(item.final_line_price);
          })() +
          '</span>' +
          '</div>' +
          '</div>' +
          '</div>';
      });
      itemsContainer.innerHTML = html;
    }

    // Calculate and show total savings (compare-at + discount savings)
    var totalSavings = 0;
    var compareData = window.cartDrawerCompareData || {};
    cart.items.forEach(function (item) {
      var comparePrice = compareData[item.variant_id];
      if (comparePrice && comparePrice > item.price) {
        totalSavings += (comparePrice - item.price) * item.quantity;
      }
      if (item.original_line_price > item.final_line_price) {
        totalSavings += item.original_line_price - item.final_line_price;
      }
    });

    var savingsEl = document.getElementById('cart-total-savings');
    var savingsAmountEl = document.getElementById('cart-savings-amount');
    if (savingsEl && savingsAmountEl) {
      if (totalSavings > 0) {
        savingsAmountEl.textContent = '-' + formatMoney(totalSavings);
        savingsEl.classList.remove('cart-drawer__total-savings--hidden');
      } else {
        savingsEl.classList.add('cart-drawer__total-savings--hidden');
      }
    }

    // Fetch compare-at prices for any new variants not in cache
    var missingVariants = [];
    cart.items.forEach(function (item) {
      if (!(item.variant_id in compareData)) {
        missingVariants.push(item);
      }
    });
    if (missingVariants.length > 0) {
      var productHandles = [];
      missingVariants.forEach(function (item) {
        var handle = item.handle || item.url.split('/products/')[1]?.split('?')[0];
        if (handle && productHandles.indexOf(handle) === -1) {
          productHandles.push(handle);
        }
      });
      Promise.all(productHandles.map(function (handle) {
        return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); });
      })).then(function (products) {
        var updated = false;
        products.forEach(function (product) {
          product.variants.forEach(function (v) {
            if (v.compare_at_price && v.compare_at_price > v.price) {
              compareData[v.id] = v.compare_at_price;
              updated = true;
            } else {
              compareData[v.id] = null;
            }
          });
        });
        window.cartDrawerCompareData = compareData;
        if (updated) {
          renderCart(cart);
        }
      }).catch(function () {});
    }

    subtotalEl.textContent = formatMoney(cart.total_price);
    updateProgress(cart.total_price);
    updateCartBubble(cart.item_count);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  // ─── Cart API helpers ───
  function fetchCart() {
    return fetch(theme.routes.cart, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function changeLineItem(line, quantity) {
    drawer.classList.add('is-loading');
    return fetch(theme.routes.cartChange, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        drawer.classList.remove('is-loading');
        return cart;
      })
      .catch(function () {
        drawer.classList.remove('is-loading');
      });
  }

  // ─── Quantity buttons ───
  itemsContainer.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-drawer__qty-btn');
    if (!btn) return;
    var line = parseInt(btn.dataset.line, 10);
    var input = btn.parentElement.querySelector('.cart-drawer__qty-input');
    var currentQty = parseInt(input.value, 10);
    if (btn.dataset.action === 'decrease') {
      changeLineItem(line, Math.max(0, currentQty - 1));
    } else if (btn.dataset.action === 'increase') {
      changeLineItem(line, currentQty + 1);
    }
  });

  itemsContainer.addEventListener('change', function (e) {
    if (e.target.classList.contains('cart-drawer__qty-input')) {
      var line = parseInt(e.target.dataset.line, 10);
      var qty = parseInt(e.target.value, 10);
      if (!isNaN(qty) && qty >= 0) {
        changeLineItem(line, qty);
      }
    }
  });

  // ─── Update cart bubble in header ───
  function updateCartBubble(count) {
    document.querySelectorAll('.cart-link__bubble').forEach(function (el) {
      if (count > 0) {
        el.classList.add('cart-link__bubble--visible');
      } else {
        el.classList.remove('cart-link__bubble--visible');
      }
    });
  }

  // ─── INTERCEPT 1: Cart icon click ───
  // Impulse uses .js-drawer-open-cart to open its own CartDrawer
  // We capture the click BEFORE Impulse does
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.js-drawer-open-cart, a[href="/cart"]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      fetchCart().then(function (cart) {
        renderCart(cart);
        openDrawer();
      });
    }
  }, true);

  // ─── INTERCEPT 2: After Impulse adds product to cart ───
  // Impulse dispatches 'ajaxProduct:added' after successful add-to-cart
  document.addEventListener('ajaxProduct:added', function () {
    fetchCart().then(function (cart) {
      renderCart(cart);
      openDrawer();
    });
  });

  // ─── INTERCEPT 3: Cart updated event ───
  document.addEventListener('cart:updated', function () {
    fetchCart().then(function (cart) {
      renderCart(cart);
    });
  });

  // ─── INTERCEPT 4: Hide Impulse's built-in cart drawer ───
  var checkImpulse = setInterval(function () {
    var cartDrawerEl = document.getElementById('CartDrawer');
    if (cartDrawerEl) {
      cartDrawerEl.style.display = 'none';
      clearInterval(checkImpulse);
    }
  }, 100);

  setTimeout(function () { clearInterval(checkImpulse); }, 5000);

  // ─── Initial render ───
  fetchCart().then(function (cart) {
    renderCart(cart);
  });
})();
